import React from 'react';
import { ShirtIcon, BookOpenIcon } from 'lucide-react';
interface EventsProps {
  onNavigate?: (page: string) => void;
}
export function Events({
  onNavigate
}: EventsProps) {
  const handleNavigate = (page: string) => {
    if (onNavigate) {
      onNavigate(page);
      window.scrollTo(0, 0);
    }
  };
  return <main className="pt-24 min-h-screen px-6" data-id="element-336">
      <div className="max-w-3xl w-full mx-auto" data-id="element-337">
        {/* Header */}
        <div className="text-center fade-section pt-12 mb-16" data-id="element-338">
          <h1 className="font-serif text-[50px] md:text-[62px] text-white mb-6" data-id="element-339">
            Private Events
          </h1>
          <div className="w-16 h-px bg-gold mx-auto mb-8" data-id="element-340" />
          <p className="font-sans text-lg text-white/70 mb-12 leading-relaxed" data-id="element-341">
            Host your next unforgettable gathering at Tempoo. From intimate
            dinners to full venue buyouts, our space offers the perfect backdrop
            for celebrating life's special moments with authentic West African
            flair.
          </p>

          <div className="bg-charcoal p-8 md:p-12 border border-white/5" data-id="element-342">
            <h2 className="font-sans text-base tracking-widest text-gold uppercase mb-6" data-id="element-343">
              Inquire About Your Event
            </h2>
            <p className="font-sans text-lg text-white/60 mb-8" data-id="element-344">
              Please contact our events team to discuss availability, custom
              menus, and bottle service packages.
            </p>
            <a href="tel:2405359729" className="inline-block border border-gold text-gold px-8 py-4 font-sans uppercase tracking-widest text-base font-medium hover:bg-gold/10 transition-all duration-300" data-id="element-345">
              Call (240) 535-9729
            </a>
          </div>
        </div>

        {/* Sub-pages: Dress Code & Menu */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 pb-28 fade-section" data-id="element-346">
          <button onClick={() => handleNavigate('dresscode')} className="bg-charcoal border border-white/5 hover:border-gold/30 p-8 text-left transition-all duration-300 group" data-id="element-347">
            <ShirtIcon className="w-8 h-8 text-gold mb-4 group-hover:scale-110 transition-transform duration-300" data-id="element-348" />
            <h3 className="font-serif text-[22px] text-white mb-2" data-id="element-349">
              Dress Code
            </h3>
            <p className="font-sans text-base text-white/50" data-id="element-350">
              Review our dress code policy before your visit. Sophisticated
              attire required.
            </p>
            <span className="inline-block mt-4 font-sans text-sm text-gold uppercase tracking-widest" data-id="element-351">
              View Policy →
            </span>
          </button>

          <button onClick={() => handleNavigate('menu')} className="bg-charcoal border border-white/5 hover:border-gold/30 p-8 text-left transition-all duration-300 group" data-id="element-352">
            <BookOpenIcon className="w-8 h-8 text-gold mb-4 group-hover:scale-110 transition-transform duration-300" data-id="element-353" />
            <h3 className="font-serif text-[22px] text-white mb-2" data-id="element-354">The Menu</h3>
            <p className="font-sans text-base text-white/50" data-id="element-355">
              Explore our West African culinary offerings and signature
              cocktails.
            </p>
            <span className="inline-block mt-4 font-sans text-sm text-gold uppercase tracking-widest" data-id="element-356">
              View Menu →
            </span>
          </button>
        </div>
      </div>
    </main>;
}